// extracted by mini-css-extract-plugin
export default {"container":"O5-z","list":"P5-z"};